import { Injectable, inject, signal } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { GetMaintenanceWithWarrantiesGQL, GetMaintenanceWithWarrantiesQuery, GetPaginatedMaintenancesGQL, GetPaginatedMaintenancesQuery , MaintenanceOrderByInput, PageInfo } from '@generated/sammathnaur.graphql'
import { Subject, firstValueFrom } from 'rxjs'
import { toSearchPageWhere } from '../../others/to-where-input'
import type { Apollo } from 'apollo-angular'

@Injectable({
  providedIn: 'root',
})
export class MaintenancesService {

  public search$: Subject<void> = new Subject()

  public readonly filterForm = new FormGroup({
    number_contains: new FormControl(''),
    companyId_in: new FormControl([] as string[]),
    locationId_in: new FormControl([] as string[]),
    equipmentId_in: new FormControl([] as string[]),
    locationSectorId_in: new FormControl([] as string[]),
    locationEnvironmentId_in: new FormControl([] as string[]),
    archived: new FormControl(false as 'all' | false | true),
  })

  public orderBy = signal<MaintenanceOrderByInput>(MaintenanceOrderByInput.NumberAsc)
  public limit = signal<number>(25)
  public offset = signal<number>(0)
  public totalCount = signal<number>(0)
  public pageInfo = signal<PageInfo | undefined>(undefined)
  public isLoading = signal<boolean>(false)
  public shouldUpdateOptions$ = new Subject<void>()
  public getPaginatedMaintenancesGQL = inject(GetPaginatedMaintenancesGQL)
  public getMaintenanceWithWarrantiesGQL = inject(GetMaintenanceWithWarrantiesGQL)

  public reset(): void {
    this.filterForm.reset()
    this.orderBy.set(MaintenanceOrderByInput.NumberAsc)
    this.limit.set(25)
    this.offset.set(0)
    this.totalCount.set(0)
    this.pageInfo.set(undefined)
    this.isLoading.set(false)
  }

  public async searchPage(): Promise<Apollo.QueryResult<GetPaginatedMaintenancesQuery>> {
    const observable$ = this.getPaginatedMaintenancesGQL.fetch({
      variables: {
        where: toSearchPageWhere(this.filterForm.getRawValue()),
        limit: this.limit(),
        offset: this.offset(),
        orderBy: this.orderBy(),
      },
    })

    return firstValueFrom(observable$)
  }

  public async getMaintenanceWithWarranties(maintenanceId: string): Promise<Apollo.QueryResult<GetMaintenanceWithWarrantiesQuery>> {
    const observable$ = this.getMaintenanceWithWarrantiesGQL.fetch({
      variables: { id: maintenanceId },
    })

    return firstValueFrom(observable$)
  }
}
